import { type PageRoute, pageRoutes } from './page-routes';

/** The icon of a menu entry, by name (the layout draws it). */
export type NavIcon =
  | 'dashboard'
  | 'imports'
  | 'products'
  | 'review'
  | 'publish'
  | 'fetch'
  | 'proxies'
  | 'jobs'
  | 'tester'
  | 'weightTable'
  | 'weightModel'
  | 'ubuyData'
  | 'storeRules'
  | 'storeTester'
  | 'imageComparison'
  | 'howWeights'
  | 'ai'
  | 'categories';

export type NavItem =
  | {
      kind: 'link';
      to: PageRoute;
      label: string;
      icon: NavIcon;
      /** Its place in the import flow (1, 2…), shown next to it. */
      step?: number;
      /** Active only on this exact address, not on the pages below it. */
      end?: boolean;
    }
  | {
      /** A step of the flow that is still being built: shown, not a link. */
      kind: 'soon';
      label: string;
      icon: NavIcon;
      step: number;
      when: string;
    };

export interface NavSection {
  title: string;
  items: readonly NavItem[];
}

/** The sidebar, in display order: the import flow step by step, then what runs behind it. */
export const mainNav: readonly NavSection[] = [
  {
    title: 'Overview',
    items: [{ kind: 'link', to: pageRoutes.dashboard, label: 'Dashboard', icon: 'dashboard', end: true }],
  },
  {
    title: 'Import flow',
    items: [
      { kind: 'link', to: pageRoutes.imports, label: 'Imports', icon: 'imports', step: 1 },
      { kind: 'link', to: pageRoutes.products, label: 'Products', icon: 'products', step: 2 },
      { kind: 'link', to: pageRoutes.review, label: 'Review', icon: 'review', step: 3 },
      { kind: 'link', to: pageRoutes.publish, label: 'Shopify & Dropbot', icon: 'publish', step: 4 },
    ],
  },
  {
    title: 'Tools',
    items: [
      { kind: 'link', to: pageRoutes.tester, label: 'Product tester', icon: 'tester' },
      { kind: 'link', to: pageRoutes.weightTable, label: 'Weight table', icon: 'weightTable' },
      { kind: 'link', to: pageRoutes.weightModel, label: 'Weight model', icon: 'weightModel' },
      { kind: 'link', to: pageRoutes.ubuyData, label: 'Ubuy data', icon: 'ubuyData' },
      { kind: 'link', to: pageRoutes.storeRules, label: 'Store rules', icon: 'storeRules' },
      { kind: 'link', to: pageRoutes.categories, label: 'Categories', icon: 'categories' },
      {
        kind: 'link',
        to: pageRoutes.storeProductsTester,
        label: 'Sawakart products weights',
        icon: 'storeTester',
      },
      { kind: 'link', to: pageRoutes.imageComparison, label: 'Image comparison', icon: 'imageComparison' },
      { kind: 'link', to: pageRoutes.howWeightsWork, label: 'How weights work', icon: 'howWeights' },
    ],
  },
  {
    title: 'Amazon',
    items: [
      { kind: 'link', to: pageRoutes.fetchRuns, label: 'Fetch runs', icon: 'fetch' },
      { kind: 'link', to: pageRoutes.proxies, label: 'Proxies', icon: 'proxies' },
    ],
  },
  {
    title: 'System',
    items: [
      { kind: 'link', to: pageRoutes.jobs, label: 'Jobs', icon: 'jobs' },
      { kind: 'link', to: pageRoutes.aiUsage, label: 'AI usage', icon: 'ai' },
    ],
  },
];
